/**
 * The deck's hand-drawn annotation motif — an underline or a circled word.
 *
 * The brand's signature device: a keyword marked as if by hand. Strokes draw
 * themselves when the surrounding <Reveal> becomes visible, and sit still when
 * the reader prefers reduced motion.
 *
 * Usage:
 *   <Annotate>one place</Annotate>
 *   <Annotate variant="circle" color="coral">stands for.</Annotate>
 */

const COLORS = {
  lavender: "hsl(var(--brand-lavender))",
  coral: "hsl(var(--brand-coral))",
  primary: "hsl(var(--primary))",
};

function Annotate({ children, variant = "underline", color = "lavender" }) {
  const stroke = COLORS[color] ?? COLORS.lavender;

  return (
    <span className="relative inline-block whitespace-nowrap">
      <span className="relative z-10">{children}</span>
      {variant === "circle" ? (
        <svg
          className="pointer-events-none absolute -inset-x-4 -inset-y-2 overflow-visible"
          viewBox="0 0 240 80"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          {/* Loops past its own start, the way a real pen does. */}
          <path
            className="annotate-path"
            pathLength="1"
            d="M228 40C228 19 180 6 120 6 60 6 12 19 12 40c0 21 48 34 108 34 60 0 108-13 108-34 0-13-19-24-48-30"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      ) : (
        <svg
          className="pointer-events-none absolute -bottom-1.5 left-0 h-2 w-full overflow-visible"
          viewBox="0 0 200 10"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            className="annotate-path"
            pathLength="1"
            d="M2 7C36 3 68 2 100 4c32 2 64 4 98 1"
            stroke={stroke}
            strokeWidth="2.5"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      )}
    </span>
  );
}

export default Annotate;
